export const headerName = {
  add: "Добавить реквизиты",
  edit: "Редактировать реквизиты",
};
export const paymentDetailsData = {
  name: {
    key: "name",
    label: "Название (рус)",
    type: "text",
    required: true,
  },
  basicValue: {
    key: "basicValue",
    label: "Базовая величина",
    type: "text",
    required: true,
  },
  nameEn: {
    key: "nameEn",
    label: "Название (анг)",
    type: "text",
    required: true,
  },
  erip: {
    key: "erip",
    label: "Путь по ЕРИП",
    type: "text",
    required: true,
  },
  requisites: {
    key: "requisites",
    label: "Реквизиты для оплаты",
    type: "text",
    required: true,
  },
};

export const getPaymentDetailsDataModal = () => paymentDetailsData;
